import { I18nContext } from 'i18n';
import React, { useContext, useRef, useState } from 'react'
import { Popover, Overlay } from 'react-bootstrap'
import { InfoButton } from './style'

const TooltipLink = ({ text, placement = 'bottom', children, link, className }) => {
  const { translate } = useContext(I18nContext)
  const [show, setShow] = useState(false)
  const pop = useRef(null)

  const handleShow = () => {
    setShow(!show)
  }

  const handleClickLink = (e) => {
    setShow(false)
    e.stopPropagation()
  }
  
  if (!text) return children

  return (
    <div className={className}>
      <InfoButton ref={pop} onMouseEnter={handleShow} onMouseLeave={handleShow}>
        {children}
        <Overlay target={pop.current} show={show} placement={placement}>
          <Popover id="popover-trigger-focus" className="p-2 pop-tooltip">
              {text}
              &nbsp;
              {link && <a href={link} onClick={(e) => handleClickLink(e)} target="_blank" rel="noopener noreferrer">{translate('toolTipLinkMessage')}</a>}
          </Popover>
        </Overlay>  
      </InfoButton>
    </div>
  );
};

export default TooltipLink;
